import React, { useState } from 'react'
import { TargetCheckbox } from 'src/components/Global/CheckBox/Checkbox'
import { PreferenceWrapper } from './style'

const Preferences = () => {
  let Checked = localStorage.getItem('PREFERENCE')
  let INITIAL_STATE
  if (Checked === 'true') {
    INITIAL_STATE = true
    console.log(INITIAL_STATE, 'check')
  } else {
    INITIAL_STATE = false
    console.log(INITIAL_STATE, 'checjgcjvk')
  }
  const [checked, setChecked] = useState(INITIAL_STATE)
  const handleChange = (e: any) => {
    setChecked(!checked)
    // return checked
  }
  if (checked) {
    localStorage.setItem('PREFERENCE', 'true')
  } else {
    localStorage.setItem('PREFERENCE', 'false')
  }
  return (
    <PreferenceWrapper>
      <h1 className="title">Preferences</h1>
      <p>Manage your preference</p>
      <TargetCheckbox onChange={handleChange} checked={checked}>
        Hide Balance
      </TargetCheckbox>
    </PreferenceWrapper>
  )
}
export { Preferences }
